import { render } from "./CompaniesList.vue?vue&type=template&id=93e453c2&scoped=true&ts=true"
import script from "./CompaniesList.vue?vue&type=script&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&lang=ts"

import "./CompaniesList.vue?vue&type=style&index=0&id=93e453c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e453c2"]])

export default __exports__